import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS_ENTITY } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
interface IUseFetchBillableMatters {
  withFavoriteInformation?: boolean;
  isFavorite?: boolean;
  withDefaultTransactionType?: boolean;
  withInvoicesOverdueInDays?: boolean;
  withHasSubMatters?: boolean;
  withHasLinkedTransactionTypes?: boolean;
  withShowOnlyOwnEntries?: boolean;
  relations?: string[];
  sortBy?: string[];
  extraFilters?: Record<string, string | number>;
  limit?: number;
  search?: string;
  fields?: string[];
}
export const useFetchBillableMatters = (params: IUseFetchBillableMatters) => {
  const fetchBillableMatters = async ({ pageParam = 1 }) => {
    const { relations: billableRelations, extraFilters: filters, ...rest } = params;
    const queryString = new URLSearchParams(
      Object.keys(rest)?.length ? toQueryString(rest as QueryParamObject) : '',
    );

    Object.entries(filters ?? {}).forEach(([key, value]) => {
      queryString.append(`filter.${key}`, String(value));
    });

    (billableRelations ?? []).forEach((rel) => queryString.append('relations', rel));

    queryString.append('page', String(pageParam));
    try {
      return await get(
        `${API_URLS_ENTITY.MATTER}${API_URLS_ENTITY.MY_BILLABLE}?${queryString.toString()}`,
      );
    } catch (error) {
      console.error('Error fetching billable matters:', error);
      throw new Error((error as { message: string }).message || 'Failed to fetch billable matters'); // Force error throwing
    }
  };

  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  } = useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['billable-matters-list', params],
    queryFn: fetchBillableMatters,
    getNextPageParam: (lastPage, allPages) => {
      const totalCount = lastPage?.meta?.totalItems ?? 0;
      const fetchedCount = allPages.flatMap((page) => page.data).length;
      return fetchedCount < totalCount ? allPages.length + 1 : undefined;
    },
  });
  return {
    data: data?.pages.flatMap((page) => page.data) ?? [],
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  };
};
